import { Globe } from 'lucide-react'
import { useLanguage } from '../../contexts/LanguageContext'

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage()

  // Toggle between languages: de -> en -> de...
  const toggleLanguage = () => {
    setLanguage(language === 'de' ? 'en' : 'de')
  }

  return (
    <button
      onClick={toggleLanguage}
      className="p-2 rounded-md bg-gray-100 hover:bg-gray-200 dark:bg-night-850 dark:hover:bg-night-800 text-gray-700 dark:text-slate-200 transition-all duration-200"
      title={`Current: ${language.toUpperCase()}`}
    >
      <Globe className="w-4 h-4" />
    </button>
  )
}
